import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DocumentPhotoPage } from './document-photo.page';

const routes: Routes = [
  { path: '', component: DocumentPhotoPage },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DocumentPhotoRoutingModule { }
